import ContactMailRoundedIcon from '@material-ui/icons/ContactMailRounded';
import WorkRoundedIcon from '@material-ui/icons/WorkRounded';
import strings from 'strings';
import { CandidateEntity, JobOrderEntity } from 'UI/constants/entityTypes';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { SvgMakeAi, SvgMessageFilled, SvgPhoneFilled } from 'UI/res';
import { hasFeatureFlag } from 'UI/utils';

const COPIES = strings.ai.generators;

export const PRESENTATION_TYPES = [
  {
    id: 'call',
    name: COPIES.presentationsMaker.types.call,
    Icon: SvgPhoneFilled
  },
  {
    id: 'sms',
    name: COPIES.presentationsMaker.types.text,
    Icon: SvgMessageFilled
  },
  {
    id: 'linkedinJobPost',
    name: COPIES.presentationsMaker.types.linkedinJobPost,
    Icon: WorkRoundedIcon
  },
  {
    id: 'linkedinInmail',
    name: COPIES.presentationsMaker.types.linkedinInMail,
    Icon: ContactMailRoundedIcon
  },
  {
    id: 'linkedinPrompt',
    isEnabled: () => hasFeatureFlag(FeatureFlags.AIGeneratorsLinkedinAIPrompt),
    name: COPIES.presentationsMaker.types.linkedinAIPrompt,
    Icon: SvgMakeAi
  }
];

export const ROLEPLAY_SCENARIOS = [
  {
    id: 'cold_call_candidate',
    presentationMakerType: 'roleplayColdCallToCandidate',
    subtitle: COPIES.roleplay.scenarios.callCandidate.subtitle,
    title: COPIES.roleplay.scenarios.callCandidate.title,
    entityTypeToSelect: JobOrderEntity.id
  },
  {
    id: 'cold_call_hiring_authority',
    presentationMakerType: 'roleplayColdCallToHa',
    subtitle: COPIES.roleplay.scenarios.callHiringAuthority.subtitle,
    title: COPIES.roleplay.scenarios.callHiringAuthority.title,
    entityTypeToSelect: CandidateEntity.id
  }
];

export const ROLEPLAY_EXPERIENCE_OPTIONS = [
  { id: '0-3', title: COPIES.roleplay.experienceOptions.junior },
  { id: '4-7', title: COPIES.roleplay.experienceOptions.medium },
  { id: '8-15', title: COPIES.roleplay.experienceOptions.expert },
  { id: '15+', title: COPIES.roleplay.experienceOptions.veteran }
];

export const ROLEPLAY_DIFFICULTY_OPTIONS = [
  {
    id: 'random',
    label: COPIES.roleplay.form.sections.difficulty.options.random.label,
    description: COPIES.roleplay.form.sections.difficulty.options.random.description
  },
  {
    id: 'easy',
    label: COPIES.roleplay.form.sections.difficulty.options.easy.label,
    description: COPIES.roleplay.form.sections.difficulty.options.easy.description
  },
  {
    id: 'medium',
    label: COPIES.roleplay.form.sections.difficulty.options.medium.label,
    description: COPIES.roleplay.form.sections.difficulty.options.medium.description
  },
  {
    id: 'hard',
    label: COPIES.roleplay.form.sections.difficulty.options.hard.label,
    description: COPIES.roleplay.form.sections.difficulty.options.hard.description
  }
];

export const ROLEPLAY_FEEDBACK_STATUSES = {
  inProgress: 1,
  analyzing: 2,
  completed: 3,
  failed: 4
};

export const AUTO_HIDE_DURATION = 7000;
